"use client"
import { StyledNormalButton } from "@/components/Inputs/button"
import AppLogoWithLabel from "@/components/SVGs/logo/logo"
import { Link } from "@mui/material"
import { useRouter } from "next/navigation"
import dynamic from "next/dynamic"

const LottiePageNotFound = dynamic(
  () => import("@/components/Lottie/404-page"),
  {
    ssr: false,
  }
)

export default function PageNotFound() {
  const router = useRouter()
  return (
    <div className="w-full min-h-screen flex justify-center items-center">
      <div className="w-full flex flex-col justify-center items-center gap-8 px-6 xxl:px-0 mx-6 xxl:ps-0">
        <Link underline="none" href="/">
          <AppLogoWithLabel />
        </Link>
        <div className="w-full flex justify-center items-center">
          <LottiePageNotFound />
        </div>

        <div className="w-[200px] flex justify-between gap-2">
          <StyledNormalButton
            className="w-[120px]"
            onClick={() => router.back()}
          >
            Go back
          </StyledNormalButton>
          <StyledNormalButton
            className="w-[120px]"
            onClick={() => router.push("/")}
          >
            Go home
          </StyledNormalButton>
        </div>
      </div>
    </div>
  )
}
